import { useLang } from "../i18n/i18n";

function Track({ hidden = false }) {
  const { t } = useLang();
  const items = ["marquee.1", "marquee.2", "marquee.3", "marquee.4", "marquee.5", "marquee.6"];
  return (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
      {items.map((key, i) => (
        <span key={i} className="flex items-center">
          <span className="px-8 font-display text-xl sm:text-2xl text-cream/80 whitespace-nowrap">{t(key)}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold inline-block" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="relative border-y border-gold/12 bg-panel/60 py-5 overflow-hidden" data-testid="marquee-band">
      <div className="flex w-max animate-marquee">
        <Track />
        <Track hidden />
      </div>
    </div>
  );
}
